export default "/_next/static/images/product--messenger-legacy-e9769688ade62ebf70fcbf88c48fc483.svg";